export default __webpack_public_path__ + "static/media/picture_scroll7.0e845dc3.jpg";